import React, { useEffect, useRef } from 'react';
import { Box, ChatHeader } from 'pcln-design-system';
import PennyToolTip from './PennyToolTip';
/**
 * DefaultModalHeader for chat modal
 * @public
 */
export const DefaultModalHeader = props => {
  const modalHeaderRef = useRef(null);
  useEffect(() => {
    if (props.onDefaultModalHeaderRendered) {
      props.onDefaultModalHeaderRendered();
    }
  }, []);
  useEffect(() => {
    // Todo This should be removed as soon as DS updates the ChatHeader to accept props to add the flexibility to hide or display the minimize Button.
    modalHeaderRef.current.querySelectorAll('button')[1].style.display = 'none';
  }, [props.speechEnabled]);
  return React.createElement(Box, {
    ref: modalHeaderRef,
    "data-testid": 'chat-header-box'
  }, React.createElement(ChatHeader, {
    onClose: props.onClose,
    onMinimize: props.onClose
  }, React.createElement(PennyToolTip, null)));
};